module.exports = __webpack_public_path__ + "static/media/white-video.6f0c19fc.mp4";